export default __webpack_public_path__ + "static/media/full-horizontal-divider.91d17053.svg";